import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=22f4e0de&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f4e0de')) {
      api.createRecord('22f4e0de', component.options)
    } else {
      api.reload('22f4e0de', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=22f4e0de&", function () {
      api.rerender('22f4e0de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8KWZhCM6oj2KV/JS/comp/FavElement.vue"
export default component.exports